module.exports = __webpack_public_path__ + "static/media/Nikhil_Kokale.72b6c664.jpg";